module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_selfie-d214997d2f73aebc6af20d40117f4731.jpg";